import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';

import { ApiPromotionService } from 'idt-ecommerce-api/_api/api-promotions/api-promotions.service';
import { ApiPromotions } from 'idt-ecommerce-api/_api/api-promotions/models/api-promotion.models';
import { ApiShippingService } from 'idt-ecommerce-api/_api/api-shipping/api-shipping.service';
import { ApiShippingMethodList } from 'idt-ecommerce-api/_api/api-shipping/models/api-shipping.models';
import { EcommerceContext } from 'idt-ecommerce-api/context/context.models';
import { ContextService } from 'idt-ecommerce-api/context/context.service';

import { ShippingMethod } from './models/shipping.model';
import { ShippingTransformer } from './transform/shipping.transformer';


@Injectable()
export class ShippingService {

  constructor(
    private readonly apiShippingService: ApiShippingService,
    private readonly apiPromotionService: ApiPromotionService,
    private readonly contextService: ContextService
  ) {}

  public getShippingMethods(includePromotions: boolean = false): Observable<ShippingMethod[]> {
    return this.contextService.getContext$().pipe(
      first(),
      switchMap((context: EcommerceContext) => {
        let promosRequest$: Observable<{ methods: ApiShippingMethodList; promos?: ApiPromotions }>;

        promosRequest$ = this.apiShippingService.getShippingMethodsUnique(
          context.store.id,
          context.currentLanguage.id
        ).pipe(
          map((methods) => ({ methods }))
        );

        if (includePromotions) {
          promosRequest$ = forkJoin([
            promosRequest$,
            this.apiPromotionService.getPromotions(
              context.store.id,
              context.currentLanguage.id
            )
          ]).pipe(
            map((requests) => ({ ...requests[0], promos: requests[1] }))
          );
        }

        return promosRequest$.pipe(
          map((response) => {
            return ShippingTransformer.getShippingMethodsUniqueFromAPI(context, response.methods, response.promos);
          })
        );
      })
    );
  }

}
